import { render } from "./SideBar.vue?vue&type=template&id=767feeaa&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"

import "./SideBar.vue?vue&type=style&index=0&id=767feeaa&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\houbkar\\WebstormProjects\\PO\\2022-PO-LMO-HTML\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767feeaa"]])

export default __exports__